import _get from 'lodash/get';
import { deliveryState } from '../../model/details/delivery';

import { DeliveryData } from '../../types/Delivery';
import { LeadDetailRawType } from '../../types/Lead';

export default function transformDeliveryState(data: LeadDetailRawType): DeliveryData {
    let _transform = {};

    /** *************************************************************************************
     *  service product transform
     ** *********************************************************************************** */
    const serviceProducts = data.serviceProducts.filter(
        (s) => s.product !== 'DEDUCTIBLE' && s.product !== 'RETURN_COSTS'
    );
    const mapServiceProduct = new Map();
    const products = serviceProducts && serviceProducts.length ? [...serviceProducts] : [deliveryState];

    mapServiceProduct.set('product', 'product');
    mapServiceProduct.set('price.net', 'priceNet');
    mapServiceProduct.set('price.gross', 'priceGross');
    mapServiceProduct.set('price.free', 'priceFree');

    _transform = products.map((product: { [key: string]: any }) => {
        let _temp: { [key: string]: any } = {};

        mapServiceProduct.forEach((uiKey, apiKey) => {
            const [type, subKey] = apiKey.split('.');
            let _v = subKey && product[type] ? product[type][subKey] : product[apiKey];

            if (_temp.product === 'PICK_UP' && uiKey === 'priceFree') {
                _v = true;
            }

            _temp = {
                ..._temp,
                [uiKey]: _v === null ? deliveryState[uiKey] : _v,
            };
        });

        return _temp;
    })[0]; // at the moment we only have one delivery product

    /** *************************************************************************************
     *  deliver details transform
     ** *********************************************************************************** */
    const mapDelivery = new Map();

    mapDelivery.set('deliveryDetails.deliveryDate', 'deliveryDate');
    mapDelivery.set('deliveryDetails.deliveryTime', 'deliveryTime');
    mapDelivery.set('deliveryDetails.deliveryType', 'deliveryType');

    mapDelivery.forEach((uiKey, apiKey) => {
        _transform = {
            ..._transform,
            [uiKey]: _get(data, apiKey, null),
        };
    });

    return _transform;
}
